// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as SortDescendingComponent} from './SortDescending.svg';

import Icon, { TIconProps } from '../Icon';

export const IconSortDescending = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <SortDescendingComponent/>
  </Icon>
));
